<template>
  <div style="width: 98%" class="mx-auto">
    <b-modal id="request_tracking" hide-footer="true" hide-header="true">
      <b-row>
        <b-col>
          <h4>Request for Tracking</h4>
          <hr />
          <br />

          <b-form @submit="request">
            <div class="form-group mb-3 input-group input-text-wrapper">
              <div class="input-group-prepend">
                <span
                  class="input-group-text"
                  style="background-color: #ffffff; border: none"
                >
                  <font-awesome-icon icon="search" style="color: #ced4da" />
                </span>
              </div>
              <b-form-input
                class="box-text-input"
                v-model="trck_no"
                type="text"
                required
                placeholder="Tracking Number"
              >
              </b-form-input>
            </div>

            <button
              style="margin-bottom: 4%"
              class="form-control signUpButtonCard button"
              type="submit"
            >
              Send Request &nbsp;
              <b-spinner
                v-if="deliverySpinner"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="track" hide-footer="true" :title="this.trck_no">
      <b-row v-for="item in getTracking" :key="item">
        <Timeline :data="item"></Timeline>
      </b-row>
    </b-modal>

    <b-row>
      <b-col lg="4">
        <b-card>
          <b-form>
            <b-form-select
              v-model="req_type"
              class="mb-3 input-select"
              required
            >
              <b-select-option :value="null" class="option"
                >Choose Type of Request</b-select-option
              >
              <b-select-option class="option" value="1"
                >Item Pick & Drop</b-select-option
              >
              <b-select-option class="option" value="2"
                >Item Delivery</b-select-option
              >
            </b-form-select>

            <b-form-select v-model="weight" class="mb-3 input-select" required>
              <b-select-option :value="null" class="option"
                >Choose Weight</b-select-option
              >
              <b-select-option class="option" value="Small"
                >Small</b-select-option
              >
              <b-select-option class="option" value="Medium"
                >Medium</b-select-option
              >
              <b-select-option class="option" value="Large"
                >Large</b-select-option
              >
            </b-form-select>
            <b-row>
              <b-col col lg="6">
                <b-form-input
                  v-model="tracking_no"
                  class="input"
                  placeholder="Tracking Number"
                  required
                  type="text"
                ></b-form-input>
              </b-col>
              <b-col col lg="6">
                <b-form-input
                  v-model="contact"
                  class="input"
                  placeholder="Phone Number"
                  required
                  type="phone"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col style="margin-top: 5px">
                <b-form-select
                  v-model="mode"
                  class="mb-3 input-select"
                  required
                >
                  <b-select-option :value="null" class="option"
                    >Choose Payment Mode</b-select-option
                  >
                  <b-select-option class="option" value="Cash on delivery"
                    >Cash on delivery</b-select-option
                  >
                </b-form-select>
              </b-col>
            </b-row>

            <b-form-group>
              <button
                class="form-control signUpButtonCard button"
                @click="requestDelivery()"
              >
                Make Request &nbsp;
                <b-spinner
                  v-if="mailSpinner"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </b-form-group>
          </b-form>

          <!-- <b-row>
                        <b-col col lg="5">
                            <button class="button signUpButtonCard" @click="requestDelivery()">Make Request</button>
                        </b-col>
                        <b-col col lg="3"/>
                        <b-col col lg="4">
                            <b-row>
                                <b-col class="order-cost" col lg="11">
                                    <span>Charge: {{ this.getCalculation.amount }}</span>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>-->
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 3%; margin-right: 1%">
      <b-col col lg="12">
        <b-card>
          <b-button
            variant="outline-danger"
            class="fa-pull-right"
            v-b-modal="'request_tracking'"
            >Track Item</b-button
          >

          <table class="table" style="margin-top: 6%">
            <thead>
              <th>Order ID</th>
              <th>Type</th>
              <th>Tracking No</th>
              <th>Location</th>
              <th>Distance</th>
              <th>Amount</th>
              <th>Payment Mode</th>
              <th>Status</th>
            </thead>
            <tbody>
              <tr v-for="order in getOrders" :key="order.id">
                <td>
                  <span class="key-label">{{ order.order_id }}</span>
                </td>
                <td>
                  <span class="label">{{ order.req_type }}</span>
                </td>
                <td>
                  <span class="label">{{ order.tracking_no }}</span>
                </td>
                <td>
                  <span class="label">{{ order.location }}</span>
                </td>
                <td>
                  <span class="label">{{ order.distance }}</span>
                </td>
                <td>
                  <span class="label">{{ order.amount }}</span>
                </td>
                <td>
                  <span class="label">{{ order.mode }}</span>
                </td>
                <td>
                  <span class="status">{{ order.delivery_status }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Timeline from "@/views/dashboard/delivery/Timeline";
import account from "@/views/home/vuex-store/account";

export default {
  name: "Delivery",
  components: { Timeline },
  data() {
    return {
      trck_no: null,
      deliverySpinner: false,
      contact: null,
      req_type: null,
      tracking_no: null,
      location: null,
      distance: null,
      weight: null,
      mode: null,
    };
  },
  mounted() {
    let data = {
      client_id: this.getClientId,
    };
    this.fetchOrders(data);
  },
  computed: {
    ...mapGetters(["getOrders", "getClientId", "getTracking"]),
    tracking_response() {
      return this.getTracking;
    },
  },
  watch: {
    tracking_response() {
      this.$bvModal.hide("request_tracking");
      this.$bvModal.show("track");
    },
  },
  methods: {
    ...mapActions([
      "fetchOrders",
      "makeTrackingRequest",
      "makeDeliveryRequest",
    ]),
    request: function (e) {
      e.preventDefault();
      let data = {
        tracking_no: this.trck_no,
      };
      this.makeTrackingRequest(data);
    },
    requestDelivery: function (evt) {
      evt.preventDefault();
      let data = {
        client_id: account.state.account.client_id,
        name: account.state.account.name,
        contact: this.contact,
        email: account.state.account.email,
        req_type: this.req_type,
        tracking_no: this.tracking_no,
        location: "Kiteezi",
        distance: 8,
        amount: 12000, //this.getCalculation.amount,
        weight: this.weight,
        mode: this.mode,
      };
      alert(JSON.stringify(data));
      //this.makeDeliveryRequest(data)
    },
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.delivery {
  width: 100%;
}

.action {
  margin-top: 30px;
  margin-left: 20px;
}

.button {
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.button:hover {
  background: #9f0012;
}

.input {
  width: 100%;
  margin-bottom: 10px;
}

.form {
  width: 100%;
  margin: 15px;
}

.results {
  width: 90%;
  margin-top: 10px;
  margin-left: 20px;
}

.key-label {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 14px;
}

.status {
  font-size: 14px;
  background: #0a7027;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  margin-left: 1px;
  font-weight: bold;
  text-align: center;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input {
  width: 100%;
  margin-bottom: 10px;
  font-size: 12px;
}

.input-select {
  width: 100%;
  font-size: 12px;
}

.option {
  font-size: 12px;
}

.action {
  width: 90%;
  margin-top: 30px;
  margin-left: 20px;
}

.order-cost {
  width: 100%;
  background: #5e5e5e;
  border-radius: 3px;
  font-size: 16px;
  color: white;
  font-weight: bold;
  padding: 8px;
}
.button {
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}

.button:hover {
  background: #9f0012;
}

.input-search {
  width: 100%;
  margin-bottom: 10px;
  padding: 5px;
}

.request-form {
  margin: 15px;
  background: white;
  border-radius: 6px;
  padding: 8px;
  box-shadow: 8px 8px 5px #a0a0a0;
}

.img-thumb {
  float: right;
}
</style>
